<div style="display: flex;">
  @if (currentPlugin?.icon) {
    <img [src]="getIconUrl(currentPlugin.icon)" width="35px" height="35px" alt="logo" style="margin-right: 15px;">
  }
  <h1 class="save-line-head">{{currentPlugin?.title_version}}</h1>
</div>

<table id="plugin-table" mat-table [dataSource]="currentPlugin?.plugin_versions" style="width: 100%;">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element" style="padding-left: 10px!important;">
      @if (currentLanguage === 'it') {
        {{element?.title_version_IT}}
      }
      @if (currentLanguage === 'en') {
        {{element?.title_version_EN}}
      }
      @if (!currentLanguage) {
        {{element?.title_version_EN}}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="download">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element" class="icon-row">
      <div>Download</div>
      <button mat-icon-button (click)="downloadPlugin(element?.file)" style="margin-left: 8px;">
        <mat-icon svgIcon='download'></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;" 
    [ngStyle]="theme === 'dark-theme' ? { 'background-color': i % 2 === 0 ? '#4c4c4c' : '#3d3d3d' } : null">></tr>
</table>

